import { Calculator, House, MapPinX, Phone } from "lucide-react";

import type { NavigationCardMetadata } from "./navigation-card";
import { NavigationCard } from "./navigation-card";

import { LanguageSwitcher } from "~/entities/i18n_";
import { Context, Tk, useTranslation2 } from "~/shared/i18n";
import { HomeSectionName } from "~/shared/routing";
import { EXCLAMATION_MARK } from "~/shared/str";

function NotFoundPage() {
  const {
    translation: { t },
    postproc: { ts },
  } = useTranslation2();

  return (
    <div className="flex h-full flex-col items-center">
      <LanguageSwitcher.Toggle className="self-end" />
      <div className="m-auto flex flex-col p-6 *:text-center">
        <p className="text-primary-lighter mb-6 animate-pulse text-9xl font-bold">404</p>
        <h1 className="mb-5 text-4xl md:text-5xl">{ts(EXCLAMATION_MARK)(Tk.PAGE_NOT_FOUND)}</h1>
        <p className="text-muted-foreground mb-6 text-xl">{t(Tk["IT_LOOKS_LIKE_THE_PAGE_..."])}</p>
        <MapPinX className="text-secondary mb-10 size-32 self-center" />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {NAVIGATION_CARDS.map((value, index) => (
            <NavigationCard key={index} {...value} />
          ))}
        </div>
      </div>
    </div>
  );
}

const NAVIGATION_CARDS: NavigationCardMetadata[] = [
  {
    Icon: House,
    titleT: Tk.HOME,
    descriptionT: Tk.RETURN_TO_THE_MAIN_PAGE,
    link: {
      sectionName: HomeSectionName.introduction,
      textT: Tk.GO_TO,
    },
  },
  {
    Icon: Calculator,
    titleT: Tk.CALCULATOR,
    descriptionT: Tk.CALCULATE_THE_COST_OF_MOVING,
    link: {
      sectionName: HomeSectionName.calculator,
      textT: Tk.CALCULATE,
    },
  },
  {
    Icon: Phone,
    titleT: {
      key: Tk.CONTACT,
      options: {
        count: 2,
      },
    },
    descriptionT: Tk.CONTACT_US,
    link: {
      sectionName: HomeSectionName.contacts,
      textT: {
        key: Tk.CONTACT,
        options: {
          context: Context.infinitive,
        },
      },
    },
  },
];

export { NotFoundPage };
